import Divider from '@mui/material/Divider';

import { Banner } from 'Components/Banner';
import { MarketplaceFilters } from 'Components/MarketplaceFilters';
import { Pagination } from 'Components/Pagination';
import { Products } from 'Components/Products';

export const Marketplace = () => {
	return (
		<>
			<Banner />
			<Divider
				sx={{
					width: '100%'
				}}
			/>
			<MarketplaceFilters />
			<Products />
			<Pagination />
		</>
	);
};
